import type { QueryClient } from '@tanstack/react-query';

import { queryKeys } from '~/utils/queryKeys';

/** Invalidates the unread-state query the inbox WS keeps live. Also called on every (re)connect:
 *  invalidate-unread pushes published while the socket was down are lost, so resync on open. */
export function invalidateInboxUnreadQueries(queryClient: QueryClient, userId: string): void {
    queryClient.invalidateQueries({ queryKey: queryKeys.getInboxUnreadSummary(userId) });
}
